
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
import ButtonSmall from './ButtonSmall.js'
export default class HandAnalyzerPanel extends PIXI.Container {
    constructor(...arg) {
        super(...arg);
        this.analyzeScore = '100';

        this.container = new PIXI.Container();
        this.addChild(this.container);


        var styleTitle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal2 = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 22 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 20 * 2,
            fill: '#FFFFFF'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });



        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 500, 500);
        //graphics.drawRoundedRect(5, 5, 390, 60, 10);

        //graphics.drawRoundedRect(5, 10, 390, 60, 10);
        graphics.drawRoundedRect(0, 0, 285, 35, 10);
        this.container.addChild(graphics);


        //textTitle
        this.textAnalyzeSummary = new PIXI.Text('Optimal Discard: 100', styleNormal2);
        this.textAnalyzeSummary.x = 10;
        this.textAnalyzeSummary.y = 5;
        //this.textTitle.anchor.set(0.5, 0);
        this.textAnalyzeSummary.scale.set(0.5);
        this.container.addChild(this.textAnalyzeSummary);


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x444444);
        graphics.lineStyle(0, 0x444444, 1);
        graphics.drawRoundedRect(225, 5, 55, 25, 10);
        graphics.alpha = 1;
        this.container.addChild(graphics);

        //AnalyzeScore
        this.textDetails = new PIXI.Text('...', styleLarge);
        this.textDetails.x = 245;
        this.textDetails.y = 3;
        this.textDetails.scale.set(0.5);
        this.container.addChild(this.textDetails);

    }
    updateLayout(){
        //this.textAnalyzeScore.text = this.analyzeScore;
        this.textAnalyzeSummary.text = 'Optimal Discard: ' + (this.analyzeScore || 0);
    }

}